export default function getBaseUri() {
  return window.location.origin
}

// Drops a single query parameter and leaves the rest of the URL intact. Used to clear the
// payment page redirect marker without taking `currency` with it - that parameter is how the
// guest's selected currency survives the trip to the payment page and back.
export function removeQueryParameter(key) {
  const url = new URL(window.location.href)

  if (!url.searchParams.has(key)) {
    return
  }

  url.searchParams.delete(key)

  window.history.replaceState({}, document.title, url.pathname + url.search)
}

export function setQueryParameters(addedParams, title) {
  const url = new URL(window.location.pathname, getBaseUri())
  const currentQuery = new URLSearchParams(window.location.search)

  const currentParams = {}
  currentQuery.forEach((value, key) => (currentParams[key] = value))

  const newParams = { ...currentParams, ...addedParams }

  Object.keys(newParams).map(key => url.searchParams.append(key, newParams[key]))
  Object.keys(newParams)
    .filter(key => newParams[key] === null)
    .map(key => url.searchParams.delete(key))

  window.history.pushState(newParams, title || '', url.search)

  return newParams
}
